import { sendHttpRequest } from "lib/fetcher";

export function getUsage(classes, startTimeStr, endTimeStr) {
  return sendHttpRequest({
    url: "/ai/metrics",
    method: "GET",
    params: {
      startedAt: startTimeStr,
      endedAt: endTimeStr,
      classes,
    },
  });
}
export function getLimit(orgId: number) {
  return sendHttpRequest({
    url: "/ai/limit",
    method: "GET",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function saveLimit(data, orgId: number) {
  Object.entries(data).forEach(([key, value]: any) => {
    if (!value?.credit) {
      data[key] = { credit: "" };
    }
  });
  return sendHttpRequest({
    url: "/ai/limit",
    method: "POST",
    headers: {
      "x-org-id": orgId,
    },
    data,
  });
}
